import {action} from 'mobx';
import {activateNotification} from '../../../../../ui/molecules/notification/activate-notification';
import {
  WorkspaceInviteCsvData,
  WorkspaceInviteFormData,
} from './workspace-invite-interface';
import {beamMasteryTasks} from '@utils/firebase-request';
import {WorkspaceInviteRequest} from './workspace-invite-request';

interface InviteNotificationOptions {
  error?: boolean;
  success?: boolean;
}

export class WorkspaceInviteController {
  constructor(private readonly request: WorkspaceInviteRequest) {}

  @action
  async newWorkspaceInvite(
    data: WorkspaceInviteFormData,
    accessToken: string,
    errorMessages?: string[],
    notifications: InviteNotificationOptions = {},
  ) {
    const {error = true, success = true} = notifications;
    try {
      const response = await this.request.WorkspaceInvite(data, accessToken);
      if (success) {
        activateNotification({
          title: 'Invitation sent',
          content: 'The invitation was sent successfully.',
          kind: 'success',
        });
      }
      beamMasteryTasks('invite_members', true);
      return response || {statusCode: 200, message: 'Invitation sent'};
    } catch (e: any) {
      const errorMessage = e?.response?.data?.message?.toLowerCase();

      const isRecognizableError =
        errorMessage &&
        errorMessages?.some((message) =>
          errorMessage.includes(message.toLowerCase()),
        );

      if (error && !isRecognizableError) {
        activateNotification({
          title: 'Error',
          content: e?.response?.data?.message,
          kind: 'error',
        });
      }
      return e?.response;
    }
  }

  async newWorkspaceInviteCsv(
    data: WorkspaceInviteCsvData,
    accessToken: string,
    notifications: InviteNotificationOptions = {},
  ) {
    const {error = true, success = true} = notifications;
    try {
      const response = await this.request.WorkspaceInviteCsv(data, accessToken);
      if (success) {
        activateNotification({
          title: 'Invitation sent',
          content: 'The invitation list was sent successfully.',
          kind: 'success',
        });
      }
      return response || {statusCode: 200, message: 'Invitation sent'};
    } catch (e: any) {
      if (error) {
        activateNotification({
          title: 'Error',
          content: e?.response?.data?.message,
          kind: 'error',
        });
      }
      return e?.response;
    }
  }
}
